import { IconWrapper } from '../runtime';
export default IconWrapper('help-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M21.75 4H6.25C5.00736 4 4 5.00736 4 6.25V21.75C4 22.9926 5.00736 24 6.25 24H21.75C22.9926 24 24 22.9926 24 21.75V6.25C24 5.00736 22.9926 4 21.75 4Z",
      "fill": 'url(#' + props.id + '03fb281d' + ')'
    }
  }), h("path", {
    "attrs": {
      "d": "M2.25 0H17.75C18.9926 0 20 1.00736 20 2.25V17.75C20 18.9926 18.9926 20 17.75 20H2.25C1.00736 20 0 18.9926 0 17.75V2.25C0 1.00736 1.00736 0 2.25 0Z",
      "fill": "#06D2F1"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.25 0H17.75C18.9926 0 20 1.00736 20 2.25V17.75C20 18.9926 18.9926 20 17.75 20H2.25C1.00736 20 0 18.9926 0 17.75V2.25C0 1.00736 1.00736 0 2.25 0Z",
      "fill": 'url(#' + props.id + '0af2eb00' + ')',
      "fill-opacity": "0.3"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.25 0H17.75C18.9926 0 20 1.00736 20 2.25V17.75C20 18.9926 18.9926 20 17.75 20H2.25C1.00736 20 0 18.9926 0 17.75V2.25C0 1.00736 1.00736 0 2.25 0Z",
      "fill": 'url(#' + props.id + '40b01932' + ')',
      "fill-opacity": "0.4"
    }
  }), h("circle", {
    "attrs": {
      "cx": "10.4651",
      "cy": "14.7352",
      "r": "1.21612",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M10.4807 11.5326V11.1506V11.1506C10.4807 10.8586 10.7723 10.5768 10.9736 10.3653C11.1591 10.1705 11.4526 9.86959 11.9174 9.4048C13.1938 8.1284 12.9901 6.57907 11.9174 5.59142C11.2251 4.954 10.0567 4.79837 9.25387 5.28937C8.30462 5.86993 8 6.59328 8 7.52076",
      "stroke": "white",
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '03fb281d',
      "x1": "6.18421",
      "y1": "3.375",
      "x2": "6.18421",
      "y2": "19.3618",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#0087F5"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#024DCE"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + '0af2eb00',
      "x1": "0.577061",
      "y1": "7.02127",
      "x2": "9.42859",
      "y2": "19.5839",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#DBF917"
    }
  }), h("stop", {
    "attrs": {
      "offset": "0.246334",
      "stop-color": "#B0F314"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#00DFFF",
      "stop-opacity": "0.01"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + '40b01932',
      "x1": "23.5",
      "y1": "13.5",
      "x2": "11.6699",
      "y2": "-0.367294",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#0700FF",
      "stop-opacity": "0.82"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#08F4EE",
      "stop-opacity": "0.01"
    }
  })])])]);
});